import axios from 'axios'
const API_URL = process.env.VUE_APP_API_URL

class EnrichmentsService {
  async list(entityType) {
    try {
      const params = {}
      if (entityType) params.entity_type = entityType
      const { data } = await axios.get(`${API_URL}/enrichments`, { params })
      return data
    } catch (error) {
      if (error.response) {
        if (error.response.status === 401) return { status: 'unauthorized', data: [] }
        if (error.response.status === 403) return { status: 'forbidden', data: [] }
      }
      return { status: 'failed', data: [] }
    }
  }

  // stats fetches an enrichment's dashboard stats map (sizing, usage, config).
  async stats(slug) {
    try {
      const { data } = await axios.get(`${API_URL}/enrichments/${slug}/stats`)
      return { status: 'success', data: data.data || {} }
    } catch (error) {
      const s = error.response?.status
      if (s === 404) return { status: 'not_found' }
      if (s === 403) return { status: 'forbidden' }
      return { status: 'failed' }
    }
  }

  // download triggers a native browser download of one artifact. Instead of
  // buffering the whole (potentially very large, e.g. the anonymization export
  // or the geo mmdb) artifact into memory via XHR — which delays the download
  // until the last byte and hides progress — it points an anchor straight at
  // the endpoint with the JWT as a query param. The API's GetIdentity accepts
  // ?token=, so the browser streams the response directly to disk and shows
  // real progress in its own download manager. The server's Content-Disposition
  // drives the timestamped filename; navigation (not XHR) also sidesteps CORS.
  download(slug, artifactId) {
    const token = localStorage.getItem('token') || ''
    const url = `${API_URL}/enrichments/${slug}/download/${artifactId}?token=${encodeURIComponent(token)}`
    const link = document.createElement('a')
    link.href = url
    // _blank so an error response (JSON, not an attachment) can't replace the
    // SPA; a successful attachment download leaves no lingering tab.
    link.target = '_blank'
    link.rel = 'noopener'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    return { status: 'success' }
  }

  // connectCredential stores a BYO credential after the server validates it.
  async connectCredential(slug, settings) {
    try {
      const { data } = await axios.post(`${API_URL}/enrichments/${slug}/credential`, { settings })
      return { status: 'success', data }
    } catch (error) {
      const s = error.response?.status
      if (s === 400) return { status: 'invalid', message: error.response?.data?.message || 'Missing required settings' }
      if (s === 422) return { status: 'rejected', message: error.response?.data?.message || 'Credential rejected by provider' }
      if (s === 403) return { status: 'forbidden' }
      return { status: 'failed' }
    }
  }

  // disconnectCredential removes a BYO credential.
  async disconnectCredential(slug) {
    try {
      await axios.delete(`${API_URL}/enrichments/${slug}/credential`)
      return { status: 'success' }
    } catch (error) {
      if (error.response?.status === 403) return { status: 'forbidden' }
      return { status: 'failed' }
    }
  }
}

export default new EnrichmentsService()
